/* eslint-disable import/prefer-default-export */
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
/* eslint-disable linebreak-style */
import Vue from 'vue';

import VueGtm from 'vue-gtm';

Vue.use(VueGtm, {
  debug: false,
});

export const Analytics = {
  methods: {
    virtualPage(category, label) {
      try {
        this.$gtm.trackEvent({
          category,
          action: 'Virtual Page View',
          label,
        });
      } catch (error) {
        console.error(error);
      }
    },
    customEvent(category, action, label, value) {
      try {
        this.$gtm.trackEvent({
          category,
          action,
          label,
          value,
        });
      } catch (error) {
        console.error(error);
      }
    },
    pushToDataLayer(eventType, eventData) {
      const { dataLayer } = window;
      const eventObject = {
        event: eventType,
        ...eventData,
      };
      dataLayer.push(eventObject);
    },
  },
};
